import React from 'react';
import styled from 'styled-components';
import { STSubscribeForm } from 'components/Form/STSubscribeForm';
import { getMarketoFormId } from 'utils/marketo';
import useDefaultSubscribeForm from 'hooks/useDefaultSubscribeForm';

const HeroWithSubscribeForm = ({ background, title, description, revealProps, ...otherProps }) => {
  const marketoFormId = getMarketoFormId(useDefaultSubscribeForm()?.marketoForm);

  return (
    <SectionContainer background={background} {...otherProps}>
      <div className="section-review-hero--container">
        <h2 className="section-review-hero--title">{title}</h2>
        <p className="section-review-hero--description">{description}</p>
        <div className="section-review-hero--subscribe-content">
          <STSubscribeForm
            data-position="Hero Subscribe"
            type="newsletter"
            buttonTitle="Subscribe"
            enableNotification={true}
            marketoFormId={marketoFormId}
            notificationMessage="Thanks for subscribing! Please check your mail to confirm your subscription"
            className="section-review-hero--subscribe-form"
            revealProps={revealProps}
          />
        </div>
      </div>
    </SectionContainer>
  );
};

export default HeroWithSubscribeForm;

const SectionContainer = styled.div`
  background: ${props => props.background};

  .section-review-hero--container {
    margin: 0 auto;
    padding: 91px 0 80px 0;

    .section-review-hero--title {
      font-size: 61px;
      font-weight: 900;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.05em;
      max-width: 914px;
      margin: 0 auto;
      padding: 0 28px;
      @media (max-width: 768px) {
        padding: 0;
      }
    }

    .section-review-hero--description {
      text-align: center;
      max-width: 900px;
      margin: 0 auto;
      margin-top: 50px;
      padding: 0 28px;
      @media (max-width: 768px) {
        padding: 0;
      }
    }

    .section-review-hero--subscribe-content {
      margin-top: 81px;
      padding: 0 28px;
      @media (max-width: 768px) {
        padding: 0;
      }

      .section-review-hero--subscribe-form {
        justify-content: center;
        button {
          background-color: ${props => props.buttonBackground};
          font-size: 23px;
          font-weight: normal;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .section-review-hero--container {
      margin: 0 auto;
      padding: 55px 0 91px;

      .section-review-hero--title {
        font-size: 36px;
        line-height: 44px;
        max-width: 590px;
      }

      .section-review-hero--description {
        font-size: 18px;
        line-height: 28px;
        margin-top: 20px;
        max-width: 590px;
      }

      .section-review-hero--subscribe-content {
        margin: 40px auto 0;
        max-width: 590px;

        .section-review-hero--subscribe-form {
          .text-field-input {
            height: 55px !important;
          }

          button {
            padding: 11px;
            font-size: 20px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-review-hero--wrapper {
      height: 610px;
    }

    .section-review-hero--container {
      margin: 0 auto;
      padding: 59px 0 91px;

      .section-review-hero--title {
        font-size: 36px;
        line-height: 42px;
      }

      .section-review-hero--description {
        font-size: 20px;
        line-height: 28px;
        margin-top: 20px;
      }

      .section-review-hero--subscribe-content {
        margin: 40px auto 0;

        .section-review-hero--subscribe-form {
          flex-direction: column;

          .ant-row.ant-form-item {
            width: 100% !important;
            padding: 0 !important;
          }

          .text-field-input {
            height: 45px !important;
          }

          button {
            width: 100%;
            padding: 7px;
            font-size: 18px;
          }
        }
      }
    }
  }
`;
